import { apiClient } from "./apiClient";

async function downloadPdf(path, payload, fallbackFilename) {
  const response = await apiClient.post(path, payload, { responseType: "blob" });
  const disposition = response.headers["content-disposition"] || "";
  const match = disposition.match(/filename=([^;]+)/);
  const filename = match ? match[1].trim() : fallbackFilename;

  const url = window.URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export const reportsApi = {
  regulatory: (reportType, year) => apiClient.post("/reports/regulatory", { report_type: reportType, year }).then((r) => r.data),
  yearEnd: (year) => apiClient.post("/reports/year-end", { year }).then((r) => r.data),
  /*
   * The two standard reports (#316). Period, not year -- everything that
   * came before was annual and on demand, which is no use to somebody
   * doing their books in July.
   *
   * The SAME call renders the PDF, because the endpoint does: one query,
   * two renderings, so a PDF cannot disagree with the screen it was
   * printed from.
   */
  revenue: (start, end) =>
    apiClient.post("/reports/revenue", { start, end }).then((r) => r.data),

  revenuePdf: (start, end) =>
    downloadPdf("/reports/revenue", { start, end, format: "pdf" },
                `revenue_${start}_to_${end}.pdf`),

  hiveActivity: (start, end) =>
    apiClient.post("/reports/hive-activity", { start, end }).then((r) => r.data),

  /* Scheduling (#317). The scheduler has run since the timer trigger
   * shipped; there was no way to CREATE a schedule, so the feature was
   * complete and unreachable. */
  schedules: () => apiClient.get("/reports/schedules").then((r) => r.data),

  schedule: (reportKind, cadence, recipients = []) =>
    apiClient.post("/reports/schedules",
                   { report_kind: reportKind, cadence, recipients })
      .then((r) => r.data),

  /* Pause, never delete: somebody who stops a monthly report in winter
   * wants it back in spring with the same recipients. */
  pauseSchedule: (scheduleId, reason) =>
    apiClient.post(`/reports/schedules/${scheduleId}/pause`, { reason })
      .then((r) => r.data),

  /* The health signal. A scheduler that stops looks exactly like a quiet
   * month, so the run log is what tells them apart. */
  scheduleRuns: (scheduleId) =>
    apiClient.get(`/reports/schedules/${scheduleId}/runs`).then((r) => r.data),

  pdf: (reportKind, year, watermark) =>
    downloadPdf(
      "/reports/pdf",
      { report_kind: reportKind, year, watermark: watermark && watermark !== "None" ? watermark : undefined },
      `${reportKind.toLowerCase()}_${year}.pdf`
    ),
};
